<div [formGroup]="getFormGroup()"
  class="group editable-side-panel-input-textual"
  [class]="subType"
  [class.hasValue]="hasValue()"
  [class.hasError]="getIndexAwareErrorMessage()"
  [class.hasBeenEdited]="hasFieldBeenEdited('serviceName') || hasFieldBeenEdited('serviceDescription') || hasFieldBeenEdited('serviceCategoryId')">

  <div formArrayName="customServices" class="w-full">

    <div [formGroupName]="formGroupNameRef"
      class="flex flex-row">

      @if (subType === 'text') {
        <mat-form-field appearance="fill">
          <mat-label>{{getLabel()}}</mat-label>
          <input #serviceNameInput matInput appGxInput
            [formControlName]="fieldId">
            @if (getIndexAwareErrorMessage()) {
              <mat-icon svgIcon="error"
              class="error-suffix-icon"></mat-icon>
            }
            @if (getIndexAwareErrorMessage()) {
              <mat-error>{{getIndexAwareErrorMessage()}}</mat-error>
            }
          </mat-form-field>
        }

        @if (subType === 'multiline_text') {
          <mat-form-field appearance="fill">
            <mat-label>{{getLabel()}}</mat-label>
            <textarea #textarea
              matInput
              appGxInput
              [formControlName]="fieldId"
              cdkTextareaAutosize
            cdkAutosizeMaxRows="6"></textarea>
            @if (getIndexAwareErrorMessage()) {
              <mat-icon svgIcon="error"
              class="error-suffix-icon"></mat-icon>
            }
            @if (getIndexAwareErrorMessage()) {
              <mat-error>{{getIndexAwareErrorMessage()}}</mat-error>
            }
          </mat-form-field>
        }

        <div class="flex flex-row w-[92px] h-[40px]">
          @if (fieldId === 'serviceName') {
            <button mat-icon-button type="button"
              class="copyIcon ml-1 invisible group-hover:visible"
              matTooltip="Remove"
              matTooltipPosition="below"
              (click)="deleteCustomService()">
              <mat-icon svgIcon="remove_circle_outline"></mat-icon>
            </button>
          }

          @if (fieldId === 'serviceName') {
            <button mat-icon-button type="button"
              class="copyIcon invisible group-hover:visible"
                [ngStyle]="{
                  'color': hasValue() ? 'var(--neutral-10)' : 'var(--neutral-60)'
                 }"
              [matTooltip]="hasValue() ? 'Copy' : ''"
              [disabled]="!hasValue()"
              matTooltipPosition="below"
              (click)="copyValue($event)">
              <mat-icon svgIcon="content_copy"></mat-icon>
            </button>
          }
        </div>

      </div>

    </div>
  </div>
